import useErrorFlags from './useErrorFlags';

export default useErrorFlags;
